import React from "react";
import ReactDOM from "react-dom";
import Modal from "react-modal";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const Popup = ({
  openModalText,
  content,
  handleDelete,
  children,
  containerClass,
  disabled,
  logic = "confirm",
  yesBttnText = "Ja",
  noBttnText = "Nee",
}) => {
  const [modalIsOpen, setIsOpen] = React.useState(false);

  const openModal = () => {
    if (disabled) {
      return;
    }
    setIsOpen(true);
  };

  const afterOpenModal = () => {};

  const closeModal = () => {
    setIsOpen(false);
  };

  const selectedYes = () => {
    setIsOpen(false);
    handleDelete();
  };

  return (
    <>
      <div className={containerClass} onClick={openModal}>
        {children}
      </div>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        contentLabel="Modal"
        style={customStyles}
        ariaHideApp={false}
      >
        <div className="olafGrid space-y-4">
          <h2>{openModalText}</h2>
          <p>{content}</p>
          <div>
            <button
              className={`cursor-pointer w-full h-[40px] flex items-center justify-center rounded-tl-[10px] rounded-br-[10px] text-sm font-bold border-2 text-[#fff] mt-4 ${
                logic == "confirm"
                  ? "bg-olaf-green-500 border-olaf-green-500"
                  : "bg-[#8B0000] border-[#8B0000]"
              }`}
              onClick={selectedYes}
            >
              {yesBttnText}
            </button>
            <button
              className={`text-sm cursor-pointer w-full h-[40px] flex items-center justify-center rounded-tl-[10px] rounded-br-[10px] text-white mt-4 font-bold ${
                logic == "confirm"
                  ? "bg-[#8B0000] border-[#8B0000]"
                  : "bg-olaf-green-500 border-olaf-green-500"
              }`}
              onClick={closeModal}
            >
              {noBttnText}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Popup;
